import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PageRoutingModule } from './page-routing.module';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from '../components/footer/footer.component';
import { PageComponent } from './page.component';
import { AngularMaterialModule } from '../angular-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatriculacionComponent } from './matriculacion/matriculacion.component';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { CambioPropiedadComponent } from './cambio-propiedad/cambio-propiedad.component';
import { JustificanteComponent } from './justificante/justificante.component';
import { PageService } from './services/page.service';
import { ExpedientesComponent } from './expedientes/expedientes.component';
import { DetalleDirective } from './expedientes/detalle-directive';
import { AuthGuard } from '../services/auth-guard.guard';
import { NullPipe } from '../pipes/null.pipe';
import { SharedModule } from '../pipes/shared.module';
import { LinechartComponent } from './home/charts/linechart/linechart.component';
import { PiechartComponent } from './home/charts/piechart/piechart.component';
import { ChartsModule } from 'ng2-charts';
import { NgbButtonsModule } from '@ng-bootstrap/ng-bootstrap';
import { DragDrogDirective } from './services/drag-drog.directive';
import { ProgressComponent } from '../components/progress/progress.component';
import { LinechartRangeComponent } from './home/charts/linechartRange/linechartRange.component';
import { InformeComponent } from './informe/informe.component';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
} from '@angular/material/dialog';
import { CocheModalComponent } from './modal/coche-modal/coche-modal.component';
import { SolicitudesComponent } from './solicitudes/solicitudes.component';
import { ClienteComponent } from '../components/cliente/cliente.component';
import { CambioModalComponent } from './modal/cambio-modal/cambio-modal.component';
import { ReduccionComponent } from './reduccion/reduccion.component';
import { MiCuentaComponent } from './mi-cuenta/mi-cuenta.component';
import { ObservacionModalComponent } from './modal/observacion-modal/observacion-modal.component';
import { ColaboradoresModalComponent } from './modal/colaboradores-modal/colaboradores-modal.component';
import { GestionUsersComponent } from './gestion/gestion-users/gestion-users.component';
import { DistintivoComponent } from './distintivo/distintivo.component';
import { FirmaComponent } from './modal/firma/firma.component';
import { EmailModalComponent } from './modal/email-modal/email-modal.component';
import { UploadFilesComponent } from '../components/modal/upload-files/upload-files.component';
import { UploadComponent } from '../components/upload/upload/upload.component';
import { SeguroComponent } from './modal/seguro/seguro.component';
import { MultipleSearchBastidorModalComponent } from '../components/modal/multiple-search-bastidor-modal/multiple-search-bastidor-modal.component';
import { MultipleSearchExpedienteModalComponent } from '../components/modal/multiple-search-expediente-modal/multiple-search-expediente-modal.component';
import { MultipleSearchMatriculaModalComponent } from '../components/modal/multiple-search-matricula-modal/multiple-search-matricula-modal.component';
import { PropagationDirective } from '../components/propagation.directive';
import { CheckSigafirmaComponent } from './modal/check-sigafirma/check-sigafirma.component';
import { NumPedidoModalComponent } from './modal/num-pedido-modal/num-pedido-modal.component';
import { CancelarPedidoComponent } from './modal/cancelar-pedido/cancelar-pedido.component';
import { CancelarFirmaComponent } from './modal/cancelar-firma/cancelar-firma.component';
import { MatriculacionAtajoModalComponent } from '../components/modales_atajos/matriculacion-atajo-modal/matriculacion-atajo-modal.component';
import { AyudaAtajoModalComponent } from '../components/modales_atajos/ayuda-atajo-modal/ayuda-atajo-modal.component';
import { DobleTrAtajoModalComponent } from '../components/modales_atajos/doble-tr-atajo-modal/doble-tr-atajo-modal.component';
import { BajaComponent } from './baja/baja.component';
import { BajaAtajoModalComponent } from '../components/modales_atajos/baja-atajo-modal/baja-atajo-modal.component';
import { DobleTransferenciaComponent } from './doble-transferencia/doble-transferencia.component';
import { FirmaExpedienteModalComponent } from './modal/firma-expediente-modal/firma-expediente-modal.component';
import { DocumentosComponent } from '../components/documentos/documentos.component';
import { DocumentSlotComponent } from '../components/document-slot/document-slot.component';
import { SolicitudesFirmaModalComponent } from './modal/solicitudes-firma-modal/solicitudes-firma-modal.component';
import { SelectorTvehiculoComponent } from '../components/selector/tvehiculo/selector-tvehiculo/selector-tvehiculo.component';
import { ContactosComponent } from './contactos/contactos.component';
import { ContactoModalComponent } from './modal/contacto-modal/contacto-modal.component';
import { NosotrosComponent } from './nosotros/nosotros.component';
import { AyudasComponent } from './ayudas/ayudas.component';
import { AyudaModalComponent } from './modal/ayuda-modal/ayuda-modal.component';
import { CompletarSolicitudComponent } from './completar-solicitud/completar-solicitud.component';
import { FirmaDocumentosComponent } from './firma-documentos/firma-documentos.component';
import { FirmaDocumentosAtajoModalComponent } from '../components/modales_atajos/firma-documentos-atajo-modal/firma-documentos-atajo-modal.component';


@NgModule({
  declarations: [
    HomeComponent,
    DocumentosComponent,
    DocumentSlotComponent,
    FooterComponent,
    PageComponent,
    MatriculacionComponent,
    CambioPropiedadComponent,
    JustificanteComponent,
    DetalleDirective,
    ExpedientesComponent,
    LinechartComponent,
    LinechartRangeComponent,
    PiechartComponent,
    DragDrogDirective,
    ProgressComponent,
    InformeComponent,
    CocheModalComponent,
    SolicitudesComponent,
    ClienteComponent,
    CambioModalComponent,
    ReduccionComponent,
    MiCuentaComponent,
    ObservacionModalComponent,
    ColaboradoresModalComponent,
    GestionUsersComponent,
    DistintivoComponent,
    FirmaComponent,
    EmailModalComponent,
    CheckSigafirmaComponent,
    UploadFilesComponent,
    UploadComponent,
    SeguroComponent,
    MultipleSearchBastidorModalComponent,
    MultipleSearchExpedienteModalComponent,
    MultipleSearchMatriculaModalComponent,
    PropagationDirective,
    NumPedidoModalComponent,
    CancelarPedidoComponent,
    CancelarFirmaComponent,
    MatriculacionAtajoModalComponent,
    DobleTrAtajoModalComponent,
    BajaComponent,
    BajaAtajoModalComponent,
    DobleTransferenciaComponent,
    FirmaExpedienteModalComponent,
    SolicitudesFirmaModalComponent,
    SelectorTvehiculoComponent,
    ContactosComponent,
    ContactoModalComponent,
    NosotrosComponent,
    AyudasComponent,
    AyudaModalComponent,
    CompletarSolicitudComponent,
    FirmaDocumentosComponent,
    FirmaDocumentosAtajoModalComponent,
  ],
  exports: [FooterComponent],
  imports: [
    SharedModule,
    CommonModule,
    PageRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    ChartsModule,
    MatDialogModule,
    FormsModule,
  ],
  providers: [
    AuthGuard,
    PageService,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
  ],
})
export class PageModule {}
